// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "8cad82ff48038c28b8b3" + "/js/" + chunkId + ".js";
};